export const LogoutUrl = "auth/logout";
export const EmailLoginUrl = "Auth/EmailLogin";
export const ProductSelectorUrl = "ssoauth/productSelector";
export const SetPasswordTicketExpiredUrl = "auth/LinkExpired?isVirtualUser=True&ticketType=0";
export const SetEmailTicketExpiredUrl = "auth/LinkExpired?isVirtualUser=True&ticketType=1";
export const ResetPasswordTicketExpiredUrl = "auth/LinkExpired?isVirtualUser=True&ticketType=2";
export const UpgradeToVirtualUserTicketExpiredUrl = "auth/LinkExpired?isVirtualUser=False&ticketType=1";

export const loginSteps = {
    enterEmail:"enterEmail", enterPassword:"enterPassword", passwordResetSent: "passwordResetSent",
    verifyEmailForm: "verifyEmailForm",
    verifyEmailInfo: "verifyEmailInfo"
};
export const linkEmailSteps = { first:"first", second:"second", enterPassword:"enterPassword" };
export const ANNOUNCEMENTS_CAROUSEL_TIMEOUT_MS = 10000;

// minimal character count that user need to type in imperonation page for searching organizations from Identifi
export const MIN_CHAR_COUNT_TO_SEARCH_ORGANIZATIONS = 3;

//Organization Products
export const ORGANIZATION_PRODUCT_SENTRI7 = "Sentri7";
export const ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION = "Sentri7Documentation";
export const ORGANIZATION_PRODUCT_QUANTIFI = "Quantifi";
export const ORGANIZATION_PRODUCT_VERIFORM = "VeriForm";
export const ORGANIZATION_PRODUCT_POCADVISOR = "POC Advisor";

export const ORGANIZATION_TEAM_PHARMACY = "Pharmacy";
export const ORGANIZATION_TEAM_INFECTION_PREVENTION = "Infection Prevention";

// unsupported browser cookie name
export const COOKIE_NAME_UNSUPPORTED_BROWSER = "unsupported_browser_reminder";
export const COOKIE_VALUE_SUPPRESS = "suppress";

//cookie names
export const COOKIE_NAME_REMEMBER_ME = "idfi_siteid";
export const COOKIE_NAME_REMEMBER_EMAIL = "idfi_email";
export const COOKIE_NAME_SITEID_SSO = "idfi_siteid_sso";
export const COOKIE_NAME_EMAIL_LOGIN = "email_login";

export const SENTRI7DOCUMENTATION_ROLE_ID = 24;
export const SENTRI7DOCUMENTATION_ROLE_NAME = "Default User";

export const REMEMEBER_EMAIL_EXPIRATION_DAYS = 365;
export const REMEMEBER_SITEID_EXPIRATION_DAYS = 365;
